
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  base: {
    dev: 'http://localhost:3000',
    staging: 'https://ats-dev.web.app',
    production: 'https://ats-prod.web.app',
  },
  api: {
    dev: 'http://localhost:5001/ats-dev-d9077/us-central1/vatsApi/api',
    staging: 'https://asia-southeast1-ats-dev-d9077.cloudfunctions.net/vatssApi/api',
    production: 'https://asia-southeast1-ats-prod-f2177.cloudfunctions.net/vatssApi/api',
  },
  docViewer: 'https://docs.google.com/gview',
  docMSOfficeViewer: 'https://view.officeapps.live.com/op/view.aspx',
  docMSOfficeViewerEmbed: 'https://view.officeapps.live.com/op/embed.aspx',
};
